import { del, get } from '../request';
import { APP_CONFIG } from '../../config';
import { Benefit } from '../../@types/benefits';
import { NotificationsResponse } from '../../@types/notifications';

export const getNotifications = async (): Promise<NotificationsResponse> => {
  return await get(`${APP_CONFIG.baseApiUrl}/konto/api/client/products/notifications`, 'XSRF-TOKEN');
};

export const acknowledgeNotification = async ({
  benefitId,
  notificationId,
}: {
  benefitId: Benefit;
  notificationId: string;
}) => {
  return await del(
    `${APP_CONFIG.baseApiUrl}/konto/api/client/products/notifications/${benefitId}/messages/${notificationId}`,
    'XSRF-TOKEN',
  );
};

export const clearNotificationMarker = async (benefitId: Benefit) => {
  return await del(
    `${APP_CONFIG.baseApiUrl}/konto/api/client/products/notifications/${benefitId}/marker`,
    'XSRF-TOKEN',
  );
};
